import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined'
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined'
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import React from 'react'
import { Link } from 'react-router-dom'
import {  Menu, MenuItemProps } from 'semantic-ui-react'
import img from '../../images/SPlogo3.png'
import Tlogo from '../../images/Tlogobig.png';
import LogoText from '../../images/Tlogo01.png';
import { TabNames } from '../Header/Header'
import './Footer.css'
import { useNavigate } from 'react-router-dom';
import logo2 from '../../images/logoM1.png';
import gif from "../../images/glowgif01.gif";
import AnchorLink from 'react-anchor-link-smooth-scroll';

export const Footer = (props: {
    activeItem: TabNames,
    handleItemClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, data: MenuItemProps) => void
}) => {
  const navigate = useNavigate();
    const scrollToTop = () => {
        window.scrollTo(0,0);
       }
       
    return (
      <footer className='footer' id='footer'>
        <div className='center2_f animate'>
            <img src={gif} className='logoIS' />

              
            
             </div>
        <div className='footer__top'>
       
        
    
           <div className='footer_in'>
            <div className='cta'>
              <h1>Where to Find Us</h1>
            </div>
            <div className='content'>
            
            <div className='footer__item'>
                
                <div className='footer-menu-title'><h4>Quick Links</h4></div>
                <Menu text vertical className='footer-menu'>
                <Menu.Item
                    className='footer-menu-item'
                    name={TabNames.HOME}
                    active={props.activeItem === TabNames.HOME}
                    onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, data: MenuItemProps) => {
                        props.handleItemClick(event, data);
                        scrollToTop();
                    }}
                    as={Link}
                    to='/'
                />
                {/* <Menu.Item
                    className='footer-menu-item'
                    name={TabNames.CONTACT}
                    active={props.activeItem === TabNames.CONTACT}
                    onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, data: MenuItemProps) => {
                        props.handleItemClick(event, data);
                        scrollToTop();
                    }}
                    as={Link}
                    to='/contact'
                /> */}  <AnchorLink href='#services'>
                 <Menu.Item
                    className='footer-menu-item'
                    name={TabNames.PRODUCTS}
                    // active={props.activeItem === TabNames.PRODUCTS}
                    // onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, data: MenuItemProps) => {
                    //     props.handleItemClick(event, data);
                    //     scrollToTop();
                    // }}
                    // as={Link}
                    // to='/product'
                /></AnchorLink>
                {/* <Menu.Item
                    className='footer-menu-item'
                    name={TabNames.MOBILE}
                    active={props.activeItem === TabNames.MOBILE}
                    onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, data: MenuItemProps) => {
                        props.handleItemClick(event, data);
                        scrollToTop();
                    }}
                    as={Link}
                    to='/apply'
                /> */}
                  <AnchorLink href='#aboutUs'>
                <Menu.Item
                    className='footer-menu-item'
                    name={TabNames.ABOUT_US}
                    // active={props.activeItem === TabNames.ABOUT_US}
                    // onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, data: MenuItemProps) => {
                    //     props.handleItemClick(event, data);
                    //     scrollToTop();
                    // }}
                    // as={Link}
                    // to='/about-us'
                /></AnchorLink>
                </Menu>
            </div>
            <div className='footer__item'>
            <div className='footer-menu-title'><h4>Address</h4></div>
            <div className='address-container'>
                <div style={{fontSize:'16px',fontFamily:'mont'}}>US Address:</div>
                  <div  > 
                  IntelleSphere LLC<br></br>
                  2879, Grand Helios Way, Henderson,

                    <br></br>
                    NV 89052 USA</div>
                  </div>
                  <div className='address-container' >
                  <div style={{fontSize:'16px',fontFamily:'mont',marginTop:'10px'}}>INDIA Address:</div>
                  <div  > 
                  IntelleSphere Pvt. Ltd.<br></br>
                  AV HUB, 4th floor 
                  <br></br> 
                  C9RP+6RJ, Vittal Rao Nagar, HITEC City, 
                  <br></br>
                  Hyderabad, Telangana 500081

                    <br></br>
                    India</div>
                    
                  </div>
               
               
                </div>
            <div className='footer__item'>
                <div className='footer-menu-title'><h4>Follow Us</h4></div>
                <div className='social-media-container'>
                <div  className='footer-menu-item3' style={{display:'flex',justifyContent:'center',}}>
                  <a href='https://www.facebook.com/profile.php?id=61582114731128'
                  target='_blank' 
                  rel='noopener noreferrer'
                  className='linkSet'
                  >
                 <FacebookIcon  className='iconL'></FacebookIcon>
                  </a>
                </div>
                <div className='footer-menu-item3'  style={{display:'flex',justifyContent:'center',}}>
                  <a href='https://www.instagram.com/intellesphere?igsh=MTJhazhwZDhramgwaA=='
                  target='_blank' 
                  rel='noopener noreferrer'
                  className='linkSet'
                  >
                 <InstagramIcon  className='iconL'></InstagramIcon>  
                  </a>
                  
                  {/* https://www.linkedin.com/company/intellesphere-llc/ */}
                 
                </div>
                <div className='footer-menu-item3'  style={{display:'flex',justifyContent:'center',}}>
                  <a href='https://x.com/intellesphere?s=11'
                  target='_blank' 
                  rel='noopener noreferrer'
                  className='linkSet'
                  >
                <XIcon   className='iconL' style={{fontSize:'32px'}}></XIcon>  
                  </a>
                  
                  {/* https://www.linkedin.com/company/intellesphere-llc/ */}
                 
                </div>
                <div className='footer-menu-item3'  style={{display:'flex',justifyContent:'center',}}>
                  <a href='https://www.linkedin.com/company/intellesphere-llc/ '
                  target='_blank' 
                  rel='noopener noreferrer'
                  className='linkSet'
                  >
                 <LinkedInIcon   className='iconL'></LinkedInIcon>  .US
                  </a>
                  
                  {/* https://www.linkedin.com/company/intellesphere-llc/ */}
                 
                </div>
                <div className='footer-menu-item3'  style={{display:'flex',justifyContent:'center',}}>
                  <a href='https://www.linkedin.com/company/intellesphere-pvt-ltd?lipi=urn%3Ali%3Apage%3Acompanies_company_about_index%3B7ed4c7a9-3312-4767-95c9-2e01d664e41d'
                  target='_blank' 
                  rel='noopener noreferrer'
                  className='linkSet'
                  >
                <LinkedInIcon   className='iconL'></LinkedInIcon>  .IN
                  </a>
                  
                  {/* https://www.linkedin.com/company/intellesphere-llc/ */}
                 
                </div>
             
                </div>
            </div>
            </div>
            <div className='cta'>
         
            </div>
            </div>
           
            <div className='footer__item1'>
            <img src={logo2} className='logo_footer' alt='IntelleSphere'  />
            {/* <img src={LogoText} alt='tekcog' height={70} style={{marginTop:'-30px',marginBottom:'20px'}} /> */}
            <div className='footer-flex2'>
                
            <div  className='footer-menu-item2' style={{marginBottom:10,paddingRight:10,color:'#88F2FF'}}>
                   <EmailOutlinedIcon className='icon1'></EmailOutlinedIcon>
                  
                     <div >
                
                  <div >recruiter@intelle-sphere.com </div>
                  </div>
                </div>
            <div  className='footer-menu-item2'>
            <LocalPhoneOutlinedIcon  className='icon1'></LocalPhoneOutlinedIcon> 
                  
                     <div >
                
                  <div  >
                  US: +1 720-414-5030</div>
                  <div  > IN: +91 8374503904</div>
                  </div>
                </div>
                </div>
        {/* <h1 className="feature__heading">SP TECHNO</h1>
      <div className="feature__heading2">SOLUTIONS INC.</div> */}
                
               
            </div>
        
        </div>
        <div className='line'></div>
        <div className='footer__item2'>
    
                {/* <a href="https://www.quinterrasoft.com/" target="_blank">
                <div className='footer__pvt2'> All Rights Reserved. | Developed by Quinterra Software Solutions Pvt. Ltd.</div></a>
               */}
               <div  className='footer-menu-item2' style={{marginRight:10,paddingRight:10,color:'#88F2FF'}}>
                   <EmailOutlinedIcon className='icon1'></EmailOutlinedIcon>
                  
                     <div >
                
                  <div >recruiter@intelle-sphere.com </div>
                  </div>
                </div>
            <div  className='footer-menu-item2'>
            <LocalPhoneOutlinedIcon  className='icon1'></LocalPhoneOutlinedIcon> 
                  
                     <div >
                
                  <div  >
US: +1 720-414-5030  </div>
                  <div  > IN: +91 8374503904</div>
                  </div>
                </div>
            </div>
      </footer>
    )
}
